import React, { createContext, useContext, useState } from 'react';
import { Client } from '../utils/types'

export type DashboardPage = 'dashboard' | 'clients' | 'leads' | 'tasks' | 'settings' | 'about' | 'feedback';

interface DashboardPageContextProps {
  page: DashboardPage;
  setPage: (page: DashboardPage) => void;
  transferedClient: Client | undefined;
  setTransferedClient: (client: Client | undefined) => void;
}

const DashboardPageContext = createContext<DashboardPageContextProps | undefined>(undefined);

export const DashboardPageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [page, setPage] = useState<DashboardPage>('dashboard');
  const [transferedClient, setTransferedClient] = useState<Client | undefined>(undefined);

  return (
    <DashboardPageContext.Provider value={{ page, setPage, transferedClient, setTransferedClient }}>
      {children}
    </DashboardPageContext.Provider>
  );
};

export const useDashboardPage = () => {
  const context = useContext(DashboardPageContext);
  if (!context) throw new Error('useDashboardPage must be used within DashboardPageProvider');
  return context;
};